var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgA(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.484h9v2.032H0v-2.032zm4.447-9.29a5.075 5.075 0 012.26.484c.659.322.988.931.988 1.827v3.408c0 .236.005.522.015.859-.006.18.036.358.12.517.078.1.181.178.299.225v.287H5.925a2.095 2.095 0 01-.128-.423 4.594 4.594 0 01-.057-.45 4.14 4.14 0 01-.966.741c-.454.246-.963.371-1.479.363a2.61 2.61 0 01-1.738-.576A2.013 2.013 0 01.87 8.823 2.1 2.1 0 011.973 6.84a5.052 5.052 0 011.778-.478l.69-.081c.273-.023.543-.08.803-.17a.587.587 0 00.434-.553.648.648 0 00-.331-.63 2.141 2.141 0 00-.97-.174 1.295 1.295 0 00-1.017.34 1.385 1.385 0 00-.284.682H1.12c.017-.58.216-1.14.569-1.603.535-.653 1.454-.98 2.758-.98zm1.222 3.994a2.24 2.24 0 01-.387.188 3.352 3.352 0 01-.537.132l-.455.082a3.03 3.03 0 00-.917.266.883.883 0 00-.47.825.85.85 0 00.29.718c.202.151.449.229.7.222.43.002.85-.127 1.205-.368.368-.246.558-.693.573-1.343l-.002-.722zM9 0v2.032H0V0h9z",
    fill: "#fff"
  })));
}

export default SvgA;